import styled from "styled-components";
import { VERTICAL_IMAGE_SPEC } from "../post-editor-vertical/PostEditorVertical.styled";

const FACEBOOK_IMAGE_SIZE_SPEC = {
  // 1.91:1 = 487:255
  web: {
    width: 487,
    pictureWidth: 487,
    minHeight: 255,
    maxHeight: 487
  },
  mobile: {
    width: 340,
    pictureWidth: 340,
    minHeight: 178,
    maxHeight: 340
  }
};

const displayLinkStyle = {
  color: "#5E646D",
  fontSize: "12px",
  lineHeight: "16px",
  fontWeight: "500",
  letterSpacing: "0.02em"
};
const titleStyle = {
  fontSize: "16px",
  lineHeight: "17px",
  fontWeight: "600",
  letterSpacing: "0px"
};
const subHeadlineStyle = {
  color: "#5E646D",
  fontSize: "14px",
  lineHeight: "16px",
  fontWeight: "400",
  letterSpacing: "0px"
};
const teaserTextStyle = {
  fontSize: "15px",
  lineHeight: "19px"
};

const PostEditorFacebookWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 554px;
  ${(props) => props.mobile && "margin: -20px 0 -30px 0;"}
`;
const MobileTop = styled.img`
  width: 430px;
`;
const MobileSide = styled.img`
  width: 44px;
`;
const MobileBottom = styled.img`
  width: 430px;
`;
const FacebookEditorWrapper = styled.div`
  ${(props) =>
    props.mobile &&
    `
    background: #fff;
    display: flex;
    align-items: flex-start;
    z-index: 1;
  `}

  width: ${({ verticalTemplate, mobile }) =>
    verticalTemplate
      ? VERTICAL_IMAGE_SPEC["facebook"][mobile ? "mobile" : "web"].width
      : FACEBOOK_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].pictureWidth}px;
`;
const FacebookEditor = styled.div`
  background: #fff;
  ${(props) =>
    props.mobile
      ? `
    box-shadow: 0px 2px 4px 0px #1516331F;
  `
      : `
    border-radius: 8px;
    border: 1px solid #E8E8EB;
    box-shadow: 0px 2px 4px 0px #1516331F;
  `}

  width: ${({ verticalTemplate, mobile }) =>
    verticalTemplate
      ? VERTICAL_IMAGE_SPEC["facebook"][mobile ? "mobile" : "web"].width
      : FACEBOOK_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].pictureWidth}px;
`;
const Header = styled.div`
  padding: 7px 7px 0;
`;

const EditorWrapper = styled.div`
  margin: 1px 7px 6px;
`;
const PhotoEditorWrapper = styled.div`
  position: relative;
`;

const FacebookInfoLogo = styled.img`
  position: absolute;
  height: 28px;
  width: 28px;
  right: 12px;
  bottom: -14px;
  z-index: 4;
`;
const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 9px 12px 16px 6px;
  justify-content: space-between;
  line-height: 16px;
  text-align: left;
  width: 100%;
`;
const FooterTextSections = styled.div`
  width: calc(100% - 80px);
`;

export {
  PostEditorFacebookWrapper,
  MobileTop,
  MobileSide,
  MobileBottom,
  FacebookEditorWrapper,
  FacebookEditor,
  Header,
  EditorWrapper,
  PhotoEditorWrapper,
  FacebookInfoLogo,
  FooterWrapper,
  FooterTextSections,
  FACEBOOK_IMAGE_SIZE_SPEC,
  displayLinkStyle,
  titleStyle,
  subHeadlineStyle,
  teaserTextStyle
};
